import { Icon } from "./Icon";
import { useTranslation } from "react-i18next";
import Container from "./Container";
import { getTrustFactLabel, TRUST_FACTS } from "./trustData";

type TrustBarVariant = "light" | "dark";

type TrustBarProps = {
  className?: string;
  variant?: TrustBarVariant;
};

export default function TrustBar({
  className = "",
  variant = "light",
}: TrustBarProps) {
  const { t } = useTranslation("trust");
  const dark = variant === "dark";

  const sectionClass = dark
    ? "border-y border-white/10 bg-slate-950 text-slate-100"
    : "border-y border-slate-200 bg-white text-slate-900";
  const itemClass = dark
    ? "border-white/10 text-slate-200"
    : "border-slate-200 text-slate-700";
  const iconClass = dark ? "text-sky-300" : "text-sky-700";

  return (
    <section className={`${sectionClass} ${className}`}>
      <Container>
        <div
          aria-label={t("ariaLabel")}
          className="flex gap-2 overflow-x-auto py-4 sm:grid sm:grid-cols-2 sm:overflow-visible md:grid-cols-3 xl:grid-cols-6"
          role="list"
        >
          {TRUST_FACTS.map((fact) => (
            <div
              key={fact.id}
              className={`flex min-w-[10.75rem] items-center gap-2 border-l px-3 py-2 text-xs font-semibold leading-snug sm:min-w-0 ${itemClass}`}
              role="listitem"
            >
              <Icon
                icon={fact.icon}
                className={`shrink-0 text-base ${iconClass}`}
              />
              <span>{getTrustFactLabel(t, fact.id)}</span>
            </div>
          ))}
        </div>
      </Container>
    </section>
  );
}
